// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { styles } from "@bg/App/Components/RfqQuoteDetails/RelatedProductItem";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.rightSectionQty = {
    css: css`
        width: 60px;
        text-align: center;
        &&& > div > div {
            border: 0 !important;
            input {
                max-width: 100%;
                border-radius: 0 !important;
                border: 1px solid ${getColor("text.main")} !important;
            }
            input:focus {
                border-width: 2px !important;
            }
        }
    `,
};
